import { z } from 'zod'
import {
  pinDetailsSearchSchema,
  PIN_DETAILS_MODALS
} from '../pinDetails-search-schemas'

export const groupsContextSearchSchema = z.object({
  search: z.string().optional(),
  activeFilter: z.enum(['Active', 'Inactive', 'Any']).optional(),
  quickFilter: z.string().optional(),
  type: z.string().optional(),
  sort: z.string().optional(),
  direction: z.enum(['ASC', 'DESC']).optional(),
  page: z.coerce.number().int().min(0).optional(),
  size: z.coerce.number().int().positive().optional()
})

/**
 * Group detail (and nested plan/pin) search schema. The legacy URL stuffed
 * `tab`, `pinOption`, `page`, `size`, `search`, `option`, `subOption`, `id`,
 * `stateFilter`, `sort`, `direction`, `quickFilter` as optional positional
 * path params — the container always read them from the query string anyway.
 * They live in the search now.
 *
 * The PinDetails overlay params (Card 4.1) are composed in via `.merge()`.
 * `modal` exists on both sides — here it is the union of the group-level
 * modals (`addToReport`, `moveToPlan`, from Card 2.11) and the PinDetails
 * modal gates, since the PinDetails overlay opens inside the group viewer.
 */
export const groupDetailSearchSchema = z
  .object({
    // pin detail state
    tab: z.string().optional(),
    pinOption: z.string().optional(),
    option: z.string().optional(),
    subOption: z.string().optional(),
    id: z.string().optional(),
    // list / filtering / pagination state
    page: z.coerce.number().int().min(0).optional(),
    size: z.coerce.number().int().positive().optional(),
    search: z.string().optional(),
    sort: z.string().optional(),
    direction: z.enum(['ASC', 'DESC']).optional(),
    quickFilter: z.string().optional(),
    stateFilter: z.string().optional()
  })
  .merge(pinDetailsSearchSchema)
  .extend({
    // ephemeral modal indicator — group-level values replace the legacy
    // `/addToReport` and `/moveToPlan` sub-routes (Card 2.11); the PinDetails
    // values are the overlay's modal gates (Cards 4.3/4.4). Set to open the
    // corresponding popup; clear to close.
    modal: z
      .enum(['addToReport', 'moveToPlan', ...PIN_DETAILS_MODALS])
      .optional()
  })
  .passthrough()
